// extracted by mini-css-extract-plugin
module.exports = {"stackcard":"points_stackcard__3Hqme","mypointscircle":"points_mypointscircle__3PWv3","pointstitle":"points_pointstitle__2hXW6","small":"points_small__2SYXh"};